export default "__VITE_ASSET__b7a8b060__"